import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  Activity, ActivityCreateDTO, ActivityOwnerType,
} from '../interfaces/crm/crm.interface';

export const ActivityService = {
  listByOwner: async (ownerType: ActivityOwnerType, ownerId: string): Promise<Activity[]> =>
    (await axios.get(ENDPOINTS.CRM.ACTIVITY.LIST_BY_OWNER(ownerType, ownerId))).data,
  create: async (dto: ActivityCreateDTO): Promise<Activity> =>
    (await axios.post(ENDPOINTS.CRM.ACTIVITY.CREATE, dto)).data,
  remove: async (id: string): Promise<void> =>
    (await axios.delete(ENDPOINTS.CRM.ACTIVITY.DELETE(id))).data,
};
